import { mutate } from 'swr';
import { ACCOUNT_KEY } from '~/api/hooks/useGetAccount';
import { postKids } from '~/api/kids';
import { postKidsBoughtNewShoes } from '~/api/kids/boughtNewShoes';
import { postKidsEdit } from '~/api/kids/edit';
import { deleteKidsRemove } from '~/api/kids/remove';
import { postKidsSelect } from '~/api/kids/select';
import { kidsServices } from '~/features/account/child/childAdapter';
import { useRequestApi } from '~/hooks/useRequestApi';
import type { ID } from '~/interfaces/common';
import { childActions } from '~/recoil/child';
import { userActions } from '~/recoil/user';
import { useFirstLoginStore } from '~/stores/firstLoginStore';

export const useKidsApi = () => {
  const setChild = childActions.useSet();
  const setUser = userActions.useSet();
  const setFirstLogin = childActions.useSetFirstLogin();
  const setFirstLoginStore = useFirstLoginStore((s) => s.setFirstLogin);

  const postKidsRequest = useRequestApi(postKids, (res) => {
    setFirstLogin(res.child_id, true);
    setFirstLoginStore(res.child_id, true);
    const child = kidsServices.childAdapter(res);
    setChild(child);
    mutate(ACCOUNT_KEY);
  });

  const postKidsEditRequest = useRequestApi(postKidsEdit, (res) => {
    const child = kidsServices.childAdapter(res);
    setChild(child);
    mutate(ACCOUNT_KEY);
  });

  const postKidsSelectRequest = useRequestApi(postKidsSelect, (res) => {
    const child_id: ID = res.child_id;
    setUser({ selected_child_id: child_id });
    mutate(ACCOUNT_KEY);
  });

  const deleteKidsRemoveRequest = useRequestApi(deleteKidsRemove, () => {
    mutate(ACCOUNT_KEY);
  });

  const postKidsBoughtNewShoesRequest = useRequestApi(postKidsBoughtNewShoes);

  return {
    postKidsRequest,
    postKidsEditRequest,
    postKidsSelectRequest,
    deleteKidsRemoveRequest,
    postKidsBoughtNewShoesRequest,
  };
};
